import e from "../../../utilities/tw.js";
const t = {
  base: e`inline-flex items-center gap-1 font-bold underline`,
  default: e`text-primary hover:text-primary-hover focus-visible:rounded focus-visible:px-1 focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary active:text-primary-active`,
  disabled: e`pointer-events-none cursor-default text-disabled focus-visible:outline-none`
};
export {
  t as textLinkStyles
};
